import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


function LineChart({ dataset, title, legend }) {
    const validDataset = Array.isArray(dataset) ? dataset.filter(value => typeof value === 'number') : [];
    const maxDataValue = validDataset.length > 0 ? Math.max(...validDataset) : 0;
    const stepSize = maxDataValue <= 10 ? 1 : maxDataValue <= 500 ? 50 : 500;

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        scales: {
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#000', // Cor das marcas no eixo X
                },

            },
            y: {
                grid: {
                    display: false,
                },
                ticks: {
                    color: '#000',
                    stepSize: stepSize, // Dynamically set step size
                    callback: function(value) {
                        return Number.isInteger(value) ? value : null; // Display only integer values
                    }
                }
            }
        },
        plugins: {

            legend: {
                position: 'right',
                maxHeight: 40,
                labels: {
                    boxWidth: 11,
                    boxHeight: 11,
                }
            },

            title: {
                display: false,
                text: title,
                font: {
                    size: 16, // Tamanho da fonte do título
                },
                color: '#000'
            },
        },
    };
    const labels = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
    const data = {
        labels,
        datasets: [
            {
                width: 40,
                label: legend,
                data: dataset,
                borderColor: '#56CCF2',
                backgroundColor: '#56CCF2',
            }
        ],
    };

    return (
        <div className="card">
            <div style={{ fontSize: 20, fontWeight: 700, borderBottom: 'none' }} className="card-header">
                {title}
            </div>
            <Line options={options} data={data} />

        </div>
    )


}

export default LineChart